#import "../../../../../../common/graphql/NotesEntityFields.graphql"

query ListCardAccountNotes($id: UUID!) {
  cardAccount(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...NotesEntityFields
      }
    }
  }
}
